// Alex - this is set up in <script> tag in wm__theme-footer.liquid

class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.maxProducts = parseInt(this.getAttribute('data-max-products')) || 12;
    this.productHandles = [];
    this.emblaInstance = null;
  }

  connectedCallback() {
    this.init();
  }

  async init() {
    await this.loadProductHandles();
    if (this.productHandles.length > 0) {
      await this.renderProducts();
    } else {
      this.style.display = 'none';
    }
  }

  loadProductHandles() {
    try {
      const stored = localStorage.getItem('shopifyProductRecentlyViewed');
      this.productHandles = stored ? JSON.parse(stored) : [];
      
      const currentHandle = this.getAttribute('data-current-handle');
      if (currentHandle) {
        this.productHandles = this.productHandles.filter(handle => handle !== currentHandle);
      }
      
      this.productHandles = this.productHandles.slice(0, this.maxProducts);
    } catch (error) {
      console.error('Error loading recently viewed:', error);
      this.productHandles = [];
    }
  }

  async renderProducts() {      
    const container = this.querySelector('[data-js-embla-container]');
    const template = this.querySelector('[data-js-recentlyviewed-template]');
    
    if (!template) {
      console.error('Template not found');
      return;
    }

    const productPromises = this.productHandles.map(handle => 
      this.fetchProductData(handle).catch(error => {
        console.error(`Error loading product ${handle}:`, error);
        return null;
      })
    );
    
    const products = await Promise.all(productPromises);
    
    products.forEach((product, index) => {
      if (!product) return;
      
      const handle = this.productHandles[index];
      const clone = template.content.cloneNode(true);
      container.appendChild(clone);
      
      const cardElement = container.lastElementChild;
      this.updateProductCard(cardElement, product, handle);
    });
  }

  formatPrice(priceInCents) {
    const price = priceInCents / 100;
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(price);
  }

  updateProductCard(cardElement, product, handle) {
    cardElement.setAttribute('data-product-handle', handle);

    // Update all links
    const productLinks = cardElement.querySelectorAll('a');
    if (productLinks.length > 0) {
      productLinks.forEach(link => {
        link.href = product.url;
        link.textContent = product.title;
      });
    }

    // Update image - clear srcset completely and rebuild
    const productImage = cardElement.querySelector('img');
    if (productImage && product.featured_image) {
      // Remove srcset to prevent browser using old URLs
      productImage.removeAttribute('srcset');
      productImage.src = product.featured_image;
      productImage.alt = product.title;
      // Optional: rebuild srcset with product image
      if (product.images && product.images.length > 0) {
        const baseUrl = product.featured_image.split('?')[0];
        productImage.srcset = `${baseUrl}?width=165 165w, ${baseUrl}?width=360 360w, ${baseUrl}?width=533 533w`;
      }
    }

    // Update price - replace entire container content
    const priceWrapper = cardElement.querySelector('.related-products-price-controls');
    if (priceWrapper) {
      const hasComparePrice = product.compare_at_price && product.compare_at_price > product.price;
      const priceHtml = hasComparePrice
        ? `<div class="price price--on-sale">
            <span class="price__regular _text-brand-dark _line-through _opacity-60">${this.formatPrice(product.compare_at_price)}</span>
            <span class="price__sale _text-brand-dark">${this.formatPrice(product.price)}</span>
          </div>`
        : `<div class="price">
            <span class="price__regular _text-brand-dark">${this.formatPrice(product.price)}</span>
          </div>`;
      priceWrapper.innerHTML = priceHtml;
    }
  }

  async fetchProductData(handle) {
    const response = await fetch(`/products/${handle}.js`);
    if (!response.ok) throw new Error('Product not found');
    return response.json();
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);